exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._cLKp{padding:20px 15px}._21JFC{overflow-y:auto;max-height:100vh;margin:0 auto}._2lSzg{position:relative;border-radius:10px;max-width:330px}._1BONa,._18jW-{position:absolute;cursor:pointer;top:3px;right:10px;font-size:22px;color:#c4c4c4}._18jW-:before{content:\"\\D7\"}", ""]);

// exports
exports.locals = {
	"rootModalContainer": "_cLKp",
	"rootModal": "_21JFC",
	"modal": "_2lSzg",
	"closeBtnIcon": "_1BONa",
	"closeBtn": "_18jW-"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1,"sourceMap":false,"modules":true,"localIdentName":"[hash:base64:5]","minimize":true,"discardComments":{"removeAll":true}}!./node_modules/postcss-loader/lib?{"config":{"path":"./tools/postcss.config.js"}}!./src/shared/components/ModalWrapper/ModalWrapper.css
// module id = 1304
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11 12 13 14 15 16 17 18 19 20 21 22 23 24 25 28 29 30 31 32 33 34 35 36 37 38 39 40 41 42 43 44 45 46